
import './style.css'

const Task = ({element,task,handleUpdateTask,theme,draggable,onDragStart,onDragEnter,onDragEnd,onDragOver})=>{

    return (
        <div draggable={draggable} 
             onDragStart= {onDragStart}
             onDragEnter= {onDragEnter}
             onDragEnd= {onDragEnd}
             onDragOver={onDragOver}
             className={'task '+theme+(draggable ? " draggable":"")} >
            <div className='checkbox' onClick={handleUpdateTask}>
                {
                task?.completed ?
                     <img src='./images/icon-check.svg' alt="checkbox"/> : <div className={'hole '+ theme}/>
                }
            </div>
            {element}
        </div>
    )
}

export default Task